import { render, staticRenderFns } from "./AccountingLegalAndPhysical.vue?vue&type=template&id=e29a3518&"
import script from "./AccountingLegalAndPhysical.vue?vue&type=script&lang=js&"
export * from "./AccountingLegalAndPhysical.vue?vue&type=script&lang=js&"
import style0 from "./AccountingLegalAndPhysical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports